import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

// create slice

const eventForm = {
  eventType: "single",
  committee: "",
  title: "",
  description: "",
  start: "",
  end: "",
  location: "hybrid",
  address: "",
  url: "",
  passcode: "",
  allDay: 0,
  repeatEvery: 1,
  period: null,
  monthFrequency:1,
  monthDaySelected:[],
  weekDaySelected: [],
};
const name = "events";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const eventsActions = { ...slice.actions, ...extraActions };
export const eventsReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    eventForm: eventForm,
    getEventListResponse: {}, //event list for grid
    getRecurrenceEventListResponse: {}, //for grid
    createEventResponse: {},
    updateEventResponse: {},
    deleteSingleEventResponse: {},
    deleteRecurrenceEventResponse: {},
    getCommitteeEventDetailsResponse: {},
    getPublicCommitteeEventDetailsResponse: {},
    updateSingleEventStatusResponse: {},
    getRecurrenceDetailsByIDResponse: {},

    getPublicSingleEventListResponse: {}, //public single event list for table
    getPublicRecurrenceEventListResponse: {}, //public recurrance event list for table
  };
}

function createReducers() {
  return {
    updateForm,
    resetForm,
    updateRecurrenceEventList,
    updatePublicRecurrenceEventList,
  };

  function updateForm(state, action) {
    state.eventForm = action?.payload;
  }

  function updateRecurrenceEventList(state, action) {
    debugger;
    state.getRecurrenceEventListResponse.data.events = action?.payload;
  }
  function updatePublicRecurrenceEventList(state, action) {
    debugger;
    state.getPublicRecurrenceEventListResponse.data.events = action?.payload;
  }

  function resetForm(state) {
    state.eventForm = eventForm;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getEventList: getEventList(),
    getRecurrenceEventList: getRecurrenceEventList(),
    createEvent: createEvent(),
    createRecurrenceEvent: createRecurrenceEvent(),
    updateEvent: updateEvent(),
    deleteSingleEvent: deleteSingleEvent(),
    deleteRecurrenceEvent: deleteRecurrenceEvent(),
    updateSingleEventStatus: updateSingleEventStatus(), //toggle
    getEventListForCalender: getEventListForCalender(),
    getCommitteeEventDetails: getCommitteeEventDetails(), //committee calender (site)
    getRecurrenceDetailsByID: getRecurrenceDetailsByID(),

    getPublicSingleEventList: getPublicSingleEventList(), //public single list
    getPublicRecurrenceEventList: getPublicRecurrenceEventList(), //public recurrence event list

    //public Events
    deleteSingleEventPublic: deleteSingleEventPublic(),
    updateSingleEventStatusPublic: updateSingleEventStatusPublic(),
    getCommitteeEventDetailsPublic: getCommitteeEventDetailsPublic(),
    updateEventPublic: updateEventPublic(),

    //public recEvents
    getPublicRecurrenceDetailsByID: getPublicRecurrenceDetailsByID(),
    deletePublicRecurrenceEvent: deletePublicRecurrenceEvent(),
  };

  function getEventList() {
    return createAsyncThunk(
      `${name}/getEventList`,
      async (params) => await fetchWrapper.get(`${baseUrl}/events${params}`)
    );
  }

  function getRecurrenceEventList() {
    return createAsyncThunk(
      `${name}/getRecurrenceEventList`,
      async (payload) =>
        await fetchWrapper.get(`${baseUrl}/recurence-events${payload}`)
    );
  }

  function createEvent() {
    return createAsyncThunk(`${name}/createEvent`, async (payload) => {
      return await fetchWrapper.post(`${baseUrl}/events`, payload);
    });
  }

  function createRecurrenceEvent() {
    return createAsyncThunk(
      `${name}/createRecurrenceEvent`,
      async (payload) => {
        return await fetchWrapper.post(`${baseUrl}/recurence-events`, payload);
      }
    );
  }

  function updateEvent() {
    return createAsyncThunk(`${name}/updateEvent`, async (payload) => {
      const id =
        payload instanceof FormData ? payload.get("_id") : payload?._id;
      return await fetchWrapper.patch(
        `${baseUrl}/events/${id}`,
        payload
      );
    });
  }

  //public
  function updateEventPublic() {
    return createAsyncThunk(`${name}/updateEventPublic`, async (payload) => {
      const id =
        payload instanceof FormData ? payload.get("_id") : payload?._id;
      return await fetchWrapper.patch(
        `${baseUrl}/events/${id}/public`,
        payload
      );
    });
  }

  //public
  function deleteSingleEventPublic() {
    return createAsyncThunk(`${name}/deleteSingleEventPublic`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/events/delete/${id}/public`);
    });
  }

  // public
  function deletePublicRecurrenceEvent() {
    return createAsyncThunk(
      `${name}/deletePublicRecurrenceEvent`,
      async (id) => {
        return await fetchWrapper.delete(
          `${baseUrl}/recurence-events/${id}/public`
        );
      }
    );
  }

  function deleteSingleEvent() {
    return createAsyncThunk(`${name}/deleteSingleEvent`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/events/delete/${id}`);
    });
  }
  function deleteRecurrenceEvent() {
    return createAsyncThunk(`${name}/deleteRecurrenceEvent`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/recurence-events/${id}`);
    });
  }

  function updateSingleEventStatus() {
    return createAsyncThunk(`${name}/updateSingleEventStatus`, async (id) => {
      return await fetchWrapper.get(`${baseUrl}/events/status-toggle/${id}`);
    });
  }

  //public
  function updateSingleEventStatusPublic() {
    return createAsyncThunk(
      `${name}/updateSingleEventStatusPublic`,
      async (id) => {
        return await fetchWrapper.get(
          `${baseUrl}/events/status-toggle/${id}/public`
        );
      }
    );
  }

  function getEventListForCalender() {
    return createAsyncThunk(
      `${name}/getEventListForCalender`,
      async (payload) => {
        return await fetchWrapper.get(
          `${baseUrl}/events/calendar?month=${payload?.month}&year=${payload?.year}`
        );
      }
    );
  }

  function getCommitteeEventDetails() {
    return createAsyncThunk(
      `${name}/getCommitteeEventDetails`,
      async (payload) => {
        return await fetchWrapper.get(`${baseUrl}/events/${payload}`);
      }
    );
  }

  //public
  function getCommitteeEventDetailsPublic() {
    return createAsyncThunk(
      `${name}/getCommitteeEventDetailsPublic`,
      async (payload) => {
        return await fetchWrapper.get(`${baseUrl}/events/${payload}/public`);
      }
    );
  }

  function getRecurrenceDetailsByID() {
    return createAsyncThunk(`${name}/getRecurrenceDetailsByID`, async (id) => {
      return await fetchWrapper.get(`${baseUrl}/recurence-events/${id}`);
    });
  }

  //public rec getPublicRecurrenceDetailsByID
  function getPublicRecurrenceDetailsByID() {
    return createAsyncThunk(
      `${name}/getPublicRecurrenceDetailsByID`,
      async (id) => {
        return await fetchWrapper.get(
          `${baseUrl}/recurence-events/${id}/public`
        );
      }
    );
  }

  function getPublicSingleEventList() {
    return createAsyncThunk(
      `${name}/getPublicSingleEventList`,
      async (params) => {
        return await fetchWrapper.get(`${baseUrl}/events/public${params}`);
      }
    );
  }
  function getPublicRecurrenceEventList() {
    return createAsyncThunk(
      `${name}/getPublicRecurrenceEventList`,
      async (params) => {
        return await fetchWrapper.get(
          `${baseUrl}/recurence-events/public${params}`
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getEventList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getEventList.fulfilled, (state, action) => {
      state.loading = false;
      state.getEventListResponse = action.payload;
    })
    .addCase(extraActions.getEventList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //get recurrence event list
    .addCase(extraActions.getRecurrenceEventList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getRecurrenceEventList.fulfilled, (state, action) => {
      state.loading = false;
      state.getRecurrenceEventListResponse = action.payload;
    })
    .addCase(extraActions.getRecurrenceEventList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //ceate event
    .addCase(extraActions.createEvent.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createEvent.fulfilled, (state, action) => {
      state.createEventResponse = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.createEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //ceate recurrence event
    .addCase(extraActions.createRecurrenceEvent.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createRecurrenceEvent.fulfilled, (state, action) => {
      state.createEventResponse = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.createRecurrenceEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //update event
    .addCase(extraActions.updateEvent.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.updateEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.updateEventResponse = action.payload;
    })
    .addCase(extraActions.updateEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //delete event
    .addCase(extraActions.deleteSingleEvent.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.deleteSingleEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteSingleEventResponse = action.payload;
    })
    .addCase(extraActions.deleteSingleEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //delete Recurrence Event
    .addCase(extraActions.deleteRecurrenceEvent.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.deleteRecurrenceEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteRecurrenceEventResponse = action.payload;
    })
    .addCase(extraActions.deleteRecurrenceEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //updateSingleEventStatus
    .addCase(extraActions.updateSingleEventStatus.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.updateSingleEventStatus.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateSingleEventStatusResponse = action.payload;
      }
    )
    .addCase(extraActions.updateSingleEventStatus.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })
    //calender
    .addCase(extraActions.getEventListForCalender.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getEventListForCalender.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getEventListForCalenderResponse = action.payload;
      }
    )
    .addCase(extraActions.getEventListForCalender.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //get Committee Event Details
    .addCase(extraActions.getCommitteeEventDetails.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getCommitteeEventDetails.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getCommitteeEventDetailsResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeEventDetails.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    //get Public Committee Event Details
    .addCase(extraActions.getCommitteeEventDetailsPublic.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getCommitteeEventDetailsPublic.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getPublicCommitteeEventDetailsResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeEventDetailsPublic.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    //get Recurrence Details ByID
    .addCase(extraActions.getRecurrenceDetailsByID.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getRecurrenceDetailsByID.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getRecurrenceDetailsByIDResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getRecurrenceDetailsByID.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    // get public event list(single)
    .addCase(extraActions.getPublicSingleEventList.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getPublicSingleEventList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getPublicSingleEventListResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getPublicSingleEventList.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    //get public event (recurrence)
    .addCase(extraActions.getPublicRecurrenceEventList.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getPublicRecurrenceEventList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getPublicRecurrenceEventListResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getPublicRecurrenceEventList.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    );
}
